import { render, staticRenderFns } from "./RequisicaoForm.vue?vue&type=template&id=5b0520cc"
import script from "./RequisicaoForm.vue?vue&type=script&lang=js"
export * from "./RequisicaoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports